// The chime that plays with the banner while the CRM is open: two short sine notes made with WebAudio,
// so there is no sound file to ship. Each browser keeps its own on/off choice in localStorage. Browsers
// only let a page make sound after the person has touched it once; until then play() is silent and never throws.
const KEY = 'tatra.notifications.sound';

export function soundEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'off';
  } catch {
    return true;
  }
}

export function setSoundEnabled(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? 'on' : 'off');
  } catch {
    // storage blocked (private mode): the choice lasts until the page is closed
  }
}

let context: AudioContext | null = null;

/** Plays the chime now (regardless of the setting: callers check soundEnabled()). */
export function playChime(): void {
  try {
    const Ctor: typeof AudioContext | undefined =
      window.AudioContext ??
      (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctor) return;
    context ??= new Ctor();
    const ctx = context;
    void ctx.resume().catch(() => undefined);
    const start = ctx.currentTime + 0.02;
    [
      { freq: 880, at: 0 },
      { freq: 1318.5, at: 0.14 },
    ].forEach(({ freq, at }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start + at);
      gain.gain.exponentialRampToValueAtTime(0.18, start + at + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + at + 0.28);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start + at);
      osc.stop(start + at + 0.3);
    });
  } catch {
    // no audio on this device: the banner still shows
  }
}
